import { Subject } from 'rxjs';
import {MacroActionValueDtoExtended} from '../ap-macro/index';
import { MacroConfigDto } from '../ap-macro/MacroConfigDto';

export class AutoCompleterSetupDto {

  macroConfigDto: MacroConfigDto;
  macroActionValue: MacroActionValueDtoExtended;
  onWarningAdded: Subject<MacroActionValueDtoExtended>;
}
